"use stric";

import api from "./apiService.js";
import WithToken from "./tokenService";
import configuration from "./../../config.json";

const routesService = {
  getRoutes: function (options) {
    return api.get("/Routes", WithToken.headersToken({ params: options }, configuration.cookieName));
  },
  createRoute: function (options) {
    return api.post(`/Routes`, options, WithToken.headersToken({}, configuration.cookieName));
  },
  deleteRoute: function (options) {
    return api.delete(`/Routes`, WithToken.headersToken({ params: { id: options.id } }, configuration.cookieName));
  },
};

export default routesService;
